import TM_IAD from './TM_IAD';
import NS_IAD from './NS_IAD';

export default {
  TM_IAD,
  NS_IAD
};
